import request from "../utils/request";

export const get = (id) => request.get(`/api/equipment/${id}`);
export const list = (data) => request.get("/api/equipment", data);
export const select = () => request.get("/api/equipment/select");
export const create = (data) => request.post("/api/equipment", data);
export const update = (id, data) => request.put(`/api/equipment/${id}`, data);
export const remove = (data) => request.del(`/api/equipment/${data}`);
export const toggle = (id) => request.put(`/api/equipment/${id}/toggle`);
